/**
 * 工具类服务
 */
export default {
  /**
   * 判断对象是否为空
   * @param {*} obj
   */
  objectKeyIsEmpty(obj) {
    let empty = null;
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null || obj[key] === "") {
          empty = true;
        } else {
          empty = false;
          break;
        }
      }
    }
    return empty;
  },

  /**
   * 图片地址转base64字符串
   * @param {*} src
   * @param {*} cb
   */
  imgUrlConverToBase64Str(src, max_Width, max_Height, cb) {
    let dataURL = "";
    let random = Math.random();
    let image = new Image();
    //这个很重要
    image.crossOrigin = "*";
    //一定要加随机数
    image.src = `${src}?v=${random}`;
    // let w = document.getElementById("pdfContent").offsetWidth;

    image.onload = () => {
      console.log(image.width, image.height);

      let maxWidth = max_Width;
      let maxHeight = max_Height;

      let width = 0;
      let height = 0;

      if (image.width < maxWidth && image.height < maxHeight) {
        width = image.width;
        height = image.height;
      } else {
        if (maxWidth / maxHeight <= image.width / image.height) {
          width = maxWidth;
          height = maxHeight;
        } else {
          width = maxHeight * (image.width / image.height);
          height = maxHeight;
        }
      }

      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, width, height);
      dataURL = canvas.toDataURL();
      cb(dataURL);
    };
  },
  /**
   * 数组分页
   * @param {*} pageNo
   * @param {*} pageSize
   * @param {*} array
   */
  pagination(pageNo, pageSize, array) {
    let offset = (pageNo - 1) * pageSize;
    return offset + pageSize >= array.length
      ? array.slice(offset, array.length)
      : array.slice(offset, offset + pageSize);
  },
  fromatDate(data) {
    let secondTime = parseInt(data); // 秒
    let minuteTime = 0; // 分
    let hourTime = 0; // 小时
    if (secondTime > 60) {
      // 如果秒数大于60，将秒数转换成整数
      // 获取分钟，除以60取整数，得到整数分钟
      minuteTime = parseInt(secondTime / 60);
      // 获取秒数，秒数取佘，得到整数秒数
      secondTime = parseInt(secondTime % 60);
      // 如果分钟大于60，将分钟转换成小时
      if (minuteTime > 60) {
        // 获取小时，获取分钟除以60，得到整数小时
        hourTime = parseInt(minuteTime / 60);
        // 获取小时后取佘的分，获取分钟除以60取佘的分
        minuteTime = parseInt(minuteTime % 60);
      }
    }
    let result = "" + parseInt(secondTime) + "″";

    if (minuteTime > 0) {
      result = "" + parseInt(minuteTime) + "′" + result;
    }
    if (hourTime > 0) {
      result = "" + parseInt(hourTime) + ":" + result;
    }
    return result;
  },
};
